
<template lang="pug">
.student-center-index-container(v-show="ready")
  .person
  .white-card
    .student-card
      .student-card-top
        img(
          src="https://m.hellobike.com/resource/AppPlatformH5/base-success/egWNBqv4YLmPFxmDVQpIa.svg"
        )
        span.ride 学生专享骑行卡
      .price
        span.span1 ¥
        span.span2 9.9
        span.start 起
        span.span3 / 30
        span.span4 天
      .before-price
        del 原价25元
      .allowance 学生专享补贴15.1元
    .ticket-container
      .ticket(v-for="item in biz")
        img.ticket-top(:src="item.icon")
        .ticket-middle {{ item.name }}
        .ticket-bottom {{ item.desc }}
  .middle(v-if="env.isEasyBikeApp")
    .down-word
      p.p1 学生特权须知
      p.p2 1.完成认证获得特权：完成学生身份认证，可获得学生专享优惠价购卡资格、免费骑行卡、出行打车、火车票购票、顺风车现金抵扣券领取资格。
      p.p3 2.一次认证长期有效：完成学生身份认证后，即可激活学生特权，可在学生中心长期享受优惠及福利政策。
      p.p4 3.学生限时活动：部分主题活动存在活动时间限制，参与时请留意活动时间。
      p.p5 4.APP领取：所有优惠及福利政策需在APP-学生特权中享受及领取。
  BizIntro.biz-intro-outside(v-if="!env.isEasyBikeApp")
  .rule.flex-mid(@click="goRule")
    span 活动规则
    .common-arrow-right
  .bottom
    .identity.flex-mid(
      @click="clickBtn",
      :class="['status-' + status, btn.subtitle ? 'with-subtitle' : '']"
    )
      .title {{ btn.title }}
      .subtitle(v-if="btn.subtitle") {{ btn.subtitle }}
  flex-modal(
    title="确认学生身份",
    ref="modal",
    sub-btn-text="修改信息",
    btn-text="确认并认证",
    @cancel="cancel",
    @close="close",
    @confirm="confirm"
  )
    .modal-text(slot="body", v-if="info")
      .modal-row
        span.modal-row-title 姓名
        span.modal-row-body {{ info.userName }}
      .modal-row
        span.modal-row-title 身份证
        span.modal-row-body {{ info.personalId }}
      .modal-row
        span.modal-row-title 学校
        span.modal-row-body {{ info.college }}
</template>

<script>
import FlexModal from '@/components/flex-modal';
import Toast from '@/components/toast';
import config from '@/const/config';
import { getBaseConfig } from '@/api/common';
import {
  getStudentAuthStatus,
  hasStudentTag,
  getStudentTagInfo,
  recordStudentStatus,
} from '@/api/student';
import { env, Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getTokenAndKey,
  getTokenAndLocation,
  isPreRender,
  tryCatch,
} from '../../utils';
import { getPort } from './utils';
import { STUDENT_AUTH_STATUS, BIZ } from './consts';
import BizIntro from './components/biz-intro.vue';

const isH5 = () => {
  const { isAliMP, isAliMPMonitor, isEasyBikeApp } = env;
  if (!isAliMP && !isAliMPMonitor && !isEasyBikeApp) {
    return true;
  }
  return false;
};

export default {
  components: {
    FlexModal,
    BizIntro,
  },
  data() {
    return {
      status: null,
      tag: false,
      info: null,
      env,
      ready: false,
      ab: false, // ab实验组
      biz: BIZ,
    };
  },
  computed: {
    btn() {
      if (this.status === STUDENT_AUTH_STATUS.AUDITING) {
        return {
          title: '审核中',
          subtitle: '可在APP查看，我们将在1-3个工作日完成审核',
        };
      }
      if (this.status === STUDENT_AUTH_STATUS.NOPASS) {
        return {
          title: '重新审核',
          subtitle: '未通过验证，请重新填写信息重试',
        };
      }
      return { title: '去认证学生身份' };
    },
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    setTimeout(() => {
      if (!this.ready) {
        this.ready = true;
      }
    }, 5000);
    const isLogin = await Native.isLogin();
    if (!isLogin) {
      this.$router.push({
        path: '/login',
        query: {
          from: '/student-center',
        },
      });
    }
    this.getData();
  },
  created() {
    this.appRedirect();
    UBT.pageView({
      pageId: 'Student_Center',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
        port: getPort(),
      },
    });
  },
  methods: {
    async getData() {
      const { token, adCode, cityCode } = await getTokenAndLocation();
      if (env.isAliMP || env.isAliMPMonitor) {
        await getBaseConfig({
          keys: ['studentBuyCardVer'],
          token,
          adCode,
          cityCode,
        }).then((v) => {
          this.ab = tryCatch(() => v.data.studentBuyCardVer.ver === '1', false);
        });
      }
      getStudentAuthStatus({ token })
        .then((v) => {
          if (v && v.data) {
            const info = v.data;
            if (info.authState === STUDENT_AUTH_STATUS.PASSED) {
              this.status = STUDENT_AUTH_STATUS.PASSED;
              this.success();
            } else {
              this.ready = true;
              if (info.authState === STUDENT_AUTH_STATUS.UNKNOWN) {
                this.status = STUDENT_AUTH_STATUS.NEVERAUTH;
              } else {
                this.status = info.authState;
              }
            }
          }
        })
        .catch(() => {
          this.ready = true;
          this.status = STUDENT_AUTH_STATUS.NEVERAUTH;
          hasStudentTag({ token }).then((v) => {
            this.tag = tryCatch(() => v.data.hitStudentTag, false);
          });
        });
    },
    cancel() {
      // 修改信息
      UBT.clickButton({
        pageId: 'Student_Center',
        buttonName: 'Authentication_pop',
        categoryId: 'platform',
        businessInfo: {
          businessType: '1',
        },
      });
      this.goAuth();
    },
    close() {
      UBT.clickButton({
        pageId: 'Student_Center',
        buttonName: 'Authentication_pop',
        categoryId: 'platform',
        businessInfo: {
          businessType: '2',
        },
      });
    },
    success() {
      let path = '/student-center/success';
      if (!isH5() && (this.ab || env.isEasyBikeApp)) {
        path = '/student-center/base';
      }
      this.$router.replace({ path, query: this.$route.query });
    },
    async confirm() {
      UBT.clickButton({
        pageId: 'Student_Center',
        buttonName: 'Authentication_pop',
        categoryId: 'platform',
        businessInfo: {
          businessType: '0',
        },
      });
      const { token, cityCode } = await getTokenAndLocation();
      const { userName, college } = this.info;
      recordStudentStatus({
        token,
        cityCode,
        userName,
        college,
      })
        .then((v) => {
          if (v && v.data && v.data.authState) {
            if (v.data.authState === STUDENT_AUTH_STATUS.PASSED) {
              this.success();
            } else {
              Toast.show(v.data.authResultMsg || '认证失败');
            }
          } else {
            Toast.show('认证失败');
          }
        })
        .catch((e) => Toast.showError(e));
    },
    goRule() {
      window.location.href = 'http://h.c3x.me/11dFcv';
    },
    async goAuth() {
      const from = window.location.href;
      window.location.replace(
        `https://m.hellobike.com/ebike-h5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/activity/student-verification.html#/activity/student-verification?from=${encodeURIComponent(
          from,
        )}`,
      );
    },
    async clickBtn() {
      if (this.status === STUDENT_AUTH_STATUS.AUDITING) {
        return;
      }
      const isLogin = await Native.isLogin();
      if (!isLogin) {
        Toast.show('请先登录');
        return;
      }
      UBT.clickButton({
        pageId: 'Student_Center',
        buttonName: 'Authentication_button',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.status === STUDENT_AUTH_STATUS.NOPASS ? '1' : '0',
        },
      });
      const { token } = await getTokenAndKey();
      if (this.tag || this.info) {
        this.info = await getStudentTagInfo({ token })
          .then((v) => v.data)
          .catch(() => null);
        UBT.moduleExpose({
          pageId: 'Student_Center',
          categoryId: 'platform',
          moduleId: 'Authentication_pop',
          contentId: 'Authentication_pop',
          exposureTimes: 1,
          businessInfo: {},
        });
        this.$refs.modal.open();
      } else {
        this.goAuth();
      }
    },
    appRedirect() {
      if (env.isEasyBikeApp) {
        window.location.replace(`https://m.hellobike.com/AppStudentCenter/${config.env !== 'pro' ? `${config.env}/` : ''}latest/pr_index_.html#`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.student-center-index-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  position: relative;
  overflow-y: auto;
  padding-top: 2.34rem;
  margin: 0;
  padding-bottom: 0.64rem;
  background: #5458ff;
  background-image: url("https://m.hellobike.com/resource/AppPlatformH5/base-success/l27gb0uh_-CCehTQr3TVr.png");
  background-repeat: no-repeat;
  background-position-y: 0;
  background-size: 100%;

  .biz-intro-outside {
    margin: 0.12rem 0.08rem 0;
  }

  .modal-text {
    display: flex;
    flex-direction: column;
    padding-left: 0.16rem;

    .modal-row {
      display: flex;
      align-items: center;
      margin-bottom: 0.08rem;

      &-title {
        width: 0.6rem;
        margin-right: 0.1rem;
        display: flex;
      }
    }
  }

  .app {
    flex-direction: column;
    width: 3.59rem;
    margin: 0.1rem auto 0;
    background: linear-gradient(180deg, #fff 0%, #fff 100%);
    border-radius: 0.08rem;
    padding: 0.24rem 0.28rem;

    .title {
      font-size: 0.16rem;
      font-weight: 500;
      color: #4b4b4b;
    }

    .subtitle {
      font-size: 0.12rem;
      color: rgba(116, 116, 146, 0.83);
    }

    .operation {
      display: flex;
      justify-content: space-between;
      margin-top: 0.26rem;
      width: 100%;

      .operation-item {
        display: flex;
        flex-direction: column;

        .pic {
          width: 1.3rem;
          height: 2.65rem;
          margin-bottom: 0.1rem;
        }

        .hint {
          font-size: 0.12rem;
          color: #5a6066;
          max-width: 1.24rem;
        }
      }
    }
  }

  .person {
    width: 3.55rem;
    height: 2.13rem;
    background-image: url("https://m.hellobike.com/resource/AppPlatformH5/base-success/u_pFTVCsG6JmRS3ggg2Pf.png");
    background-repeat: no-repeat;
    position: absolute;
    background-size: 100% 100%;
    top: 0.2rem;
    right: 0;
  }

  .white-card {
    position: relative;
    margin: 0 0.08rem;
    padding: 0 0 0.16rem 0;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/base-success/HPeWVDHjyuAqo6kiX2bAx.png);
    background-size: 100% 100%;
    top: -1px;

    .student-card {
      width: 3.44rem;
      height: 1.48rem;
      top: -0.03rem;
      left: -0.04rem;
      background-image: url("https://m.hellobike.com/resource/AppPlatformH5/base-success/T857Ag8d5p_dFxZ2q6AeC.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      margin-left: 0.12rem;

      .student-card-top {
        width: 0.15rem;
        position: absolute;

        img {
          position: absolute;
          left: 0.21rem;
          top: 0.18rem;
          width: 0.15rem;
          height: 0.13rem;
        }

        .ride {
          height: 0.18rem;
          font-size: 0.13rem;
          position: absolute;
          left: 0.41rem;
          top: 0.15rem;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
          text-shadow: 0 0 0 rgba(0, 119, 255, 0.38);
        }
      }

      .price {
        position: absolute;
        left: 0.17rem;
        top: 0.78rem;
        width: 1.07rem;
        height: 0.48rem;
        text-align: center;
        color: #fff;
        text-shadow: 0 0 0 rgba(2, 160, 225, 0.65);

        .span1 {
          position: absolute;
          top: 0.2rem;
          left: 0.05rem;
          font-size: 0.16rem;
          font-weight: 500;
        }

        .start {
          font-size: 0.12rem;
          font-weight: 600;
          color: #fff;
          position: absolute;
          top: 0.24rem;
          left: 0.64rem;
          line-height: 0.17rem;
          text-shadow: 0 0 0 rgba(2, 160, 225, 0.65);
        }

        .span2 {
          position: absolute;
          top: 0.01rem;
          left: 0.17rem;
          margin-left: 0.01rem;
          font-size: 0.4rem;
          font-family: "DIN Alternate Bold", sans-serif;
        }

        .span3 {
          position: absolute;
          top: 0.2rem;
          left: 0.78rem;
          white-space: nowrap;
          font-size: 0.2rem;
          font-family: "DIN Alternate Bold", sans-serif;
        }

        .span4 {
          position: absolute;
          top: 0.25rem;
          left: 1.11rem;
          font-size: 0.12rem;
        }
      }

      .before-price {
        position: absolute;
        left: 1.46rem;
        top: 0.85rem;
        height: 0.14rem;
        font-size: 0.1rem;
        font-weight: 400;
        color: #5ec4fe;
        line-height: 0.14rem;
      }

      .allowance {
        position: absolute;
        left: 1.46rem;
        top: 1.01rem;
        width: 1.15rem;
        height: 0.18rem;
        text-align: center;
        font-size: 0.11rem;
        border-radius: 0.09rem;
        color: #fff;
        border: 0.01rem solid #fff;
      }
    }

    .ticket-container {
      white-space: nowrap;
      overflow-y: hidden;
      width: 100%;
      padding-right: 0.12rem;
      margin-top: 0.18rem;
      padding-left: 0.12rem;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      .ticket {
        position: relative;
        height: 0.7rem;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.16rem;

        &:not(:last-of-type) {
          margin-right: 0.18rem;
        }

        .ticket-top {
          width: 0.32rem;
          height: 0.32rem;
        }

        .ticket-middle {
          font-size: 0.13rem;
          font-weight: 500;
          color: #242729;
          line-height: 0.18rem;
          margin-top: 4px;
          margin-bottom: 2px;
        }

        .ticket-bottom {
          font-size: 0.11rem;
          color: #879099;
          line-height: 0.16rem;
        }
      }
    }
  }

  .middle {
    position: relative;
    margin-top: 0.2rem;
    margin-bottom: 0.05rem;

    .down-word {
      color: #fff;
      margin: 0 0.18rem 0 0.21rem;

      .p1 {
        font-size: 0.14rem;
      }

      .p2,
      .p3,
      .p4,
      .p5 {
        margin-top: 0.1rem;
        font-size: 0.12rem;
      }

      .icon-dayuhao {
        font-size: 0.12rem;
      }
    }
  }

  .rule {
    font-size: 0.12rem;
    color: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.28rem;
  }

  .bottom {
    width: 100%;
    height: 0.73rem;
    background: #fff;
    box-shadow: 0 0.02rem 0.04rem 0 rgba(0, 0, 0, 0.5);
    padding: 0.13rem 0.2rem;
    position: fixed;
    bottom: 0;

    .identity {
      flex-direction: column;
      height: 0.48rem;
      font-size: 0.18rem;
      text-align: center;
      border-radius: 0.24rem;
      color: #fff;
      box-shadow:
        0 0.01rem 0 0 rgba(37, 37, 37, 0.17),
        0 0.01rem 0.02rem 0 rgba(218, 253, 255, 0.79);
      background: linear-gradient(180deg, #57c7fe 0%, #08f 100%);

      .subtitle {
        font-size: 0.12rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.64);
      }

      &.with-subtitle {
        .title {
          font-size: 0.16rem;
        }
      }

      &.status-1 {
        background: #e1e6eb;

        .title {
          color: #5a6066;
        }

        .subtitle {
          color: rgba(90, 96, 102, 0.66);
        }
      }
    }
  }
}
</style>
